export const ncExtent = [ 384209.7796, 37702.8231, 3084565.6507, 1071912.9892];
export const jcExtent = [ 2077288, 544530, 2283368, 751610];

const allConstants = {
  jcExtent,
  ncExtent,
};

export default allConstants;
